import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_EXTRAS_METHOD = "PATCH";
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_EXTRAS_PATH_SUFFIX = "/extras/update";
/** /customer/subscription/fresh/extras/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_EXTRAS_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_UPDATE_EXTRAS_PATH_SUFFIX
}`;
